<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <Header/>
  <loading
      :active.sync="loading"
      :is-full-page="true"
  ></loading>
  <b-container fluid>
    <br/>
  <b-row  sm="12" md="12" lg="12" xl="12" >
    <b-col lg="8" xl="8" sm="6" md="6" >
      <div class="contenedorInversion" >

       <div class="d-flex justify-content-center">
        <div class="d-flex align-items-center justify-content-between pl-4 pr-4 box letterSizeSm ">
          <span> {{ datosPacienteBasico.nombreCompleto }} </span>
          <span  style="color: #65C045"> {{ datosPacienteBasico.motivoCita }}</span>
        </div>
       </div>

       <div class="d-flex justify-content-end mr-2">
        <b-row>
          <b-col>
            <herramientas-modal v-if="datosPacienteBasico.idPaciente !== null" :idPacienteExp="datosPacienteBasico.idPaciente"></herramientas-modal>
          </b-col>
          <b-col>
            <observaciones-cita :idCita="datosPacienteBasico.idCita"></observaciones-cita>
          </b-col>
        </b-row>
       </div>

        <div class="text-center" v-if="idEtapa != 89">
          <p  style="color: #4C9CCD; font-size: .85em; font-weight: 600;">Presentación por edición</p>
        </div>

       <p class="text-left" style="color: #4C9CCD; font-size: .85em; font-weight: 600;">Inversión de tratamientos detectados</p>
       <div class="d-flex justify-content-center">
        <div class="d-flex" style=" border-radius: 20px; background-color: #E9E9E9;  width: 280px; height: 30px; " v-if="presuntivos.length > 1">
              <div class="d-flex justify-content-center align-items-center" style=" height: 30px;"
                   @click="presuntivoSeleccionado = opt.opcion"
                   :class="presuntivoSeleccionado === opt.opcion ? 'presuntivos seleccionado' : 'presuntivos'"
                   v-for="(opt, index) in presuntivos" :key="index" :title="opt.nombre">
                <p class="mt-3" :class="presuntivoSeleccionado === opt.opcion ? 'tabpresuntivosSeleccionado' : 'tabpresuntivos'">
                  {{ opt.nombre }}
                </p>
              </div>
            </div>
       </div>

        <div class="d-flex justify-content-end" style="margin-right: -1%;">
          <div class="d-flex justify-content-center align-items-center" style="padding-left: 2%; padding-right: 2%; height: 2.5em"
               @click="opcionTabSeleccionada = index"
               :class="opcionTabSeleccionada == index ? 'tabOpciones seleccionado' : 'tabOpciones'"
               v-for="(opt, index) in opciones" :key="index" :title="opt.nombre">
            <p class="mt-3" :class="opcionTabSeleccionada == index ? 'tabTxtSeleccionado' : 'tabTxt'">
              {{ opt.nombre }}
            </p>
          </div>
        </div>

        <div v-show="opcionTabSeleccionada === 0" class="text-left" style=" margin-top: 8px;">
          <div class="d-flex justify-content-between" style="margin-top: -1%;">
            <div class="d-flex align-items-center" style="height: 30px;">
                <em class="estrella" style="margin-top: -4%;"/>
                <p class="ml-2" style="color: #05375C; font-size: .8em; font-weight: 600; margin-top: 7%;">Prioridad clínica</p>
            </div>
            <div>
              <b-button v-if="!agrupadoPorOD && $localStorageService.can('BT_ordenaOD')" size="sm" variant="outline-info" pill
                          v-b-tooltip.hover.lefttop.v-light
                          title="Agrupar por OD" style="width: 25px; height: 25px" class="pl-0 pr-0 mr-2 ml-2"
                          @click="agruparPorOd(true)">
                  <em class="dienteAzulClaro_svg"/>
                </b-button>
                <b-button v-if="agrupadoPorOD && $localStorageService.can('BT_ordenaOD')" size="sm" variant="outline-info" pill
                          v-b-tooltip.hover.lefttop.v-light
                          title="Agrupar por Tx" style="width: 25px; height: 25px" class="pl-0 pr-0 mr-2 ml-2"
                          @click="agruparPorOd(false)">
                  <em class="dienteAzulClaro_svg"/>
                </b-button>
                <b-button v-if="!agrupadoPorOD && idEtapa == 89 && $localStorageService.can('imprimir_negociacion_m2')" size="sm" variant="outline-info" pill
                          v-b-tooltip.hover.lefttop.v-light
                          title="Imprimir entregable" style="width: 25px; height: 25px" class="p-0 mr-2 ml-2"
                          @click="alertImprimir" :disabled="loaderPdf">
                  <em v-if="!loaderPdf" class="impresora"/>
                  <b-spinner v-if="loaderPdf" small></b-spinner>
                </b-button>
            </div>
          </div>

          <TablaPrioridadClinica
              v-if="!agrupadoPorOD"
              class="mt-3"
              ref="tablaPrioridadClinica"
              :presuntivoSeleccionado="presuntivoSeleccionado"
              :tratamientosPrioridad="tratamientosPrioridad"
              :tratamientosPrioridadPorOD="tratamientosPrioridadPorOD"
              :promociones="promociones"
              :totalPrioridadClinica="totalPrioridadClinica"
              @dientesSeleccionados="dientesSeleccionados = $event"
              @agregarAResumenInversion="agregarAResumenInversion"
              @pasarDePrioridadAHallazgo="pasarDePrioridadAHallazgo"
              @montoAhorradoByPromocion="montoAhorradoByPromocion"
              @montosByRetiroPromo="montosByRetiroPromo"
              @enviarIndividualAHallazgo="enviarIndividualAHallazgo"
              @enviarGrupoAHallazgo="enviarGrupoAHallazgo"
              :idPti="parseInt(idPti)"
              :idSolicitudEtapa="parseInt(idSolicitudEtapa)"
              :idSolicitud="parseInt(idSolicitud)"
              :idEtapa="idEtapa"
              :aplicaPromocionesTx="aplicaPromocionesTx"
              :existePlan="existePlan"
              @montoAhorradoPromoByOD="montoAhorradoPromoByOD"
              @activarEnResumenInversion="activarEnResumenInversion"
              @cantidadTotalPrioridad="setCantidadTotal"
              :idEtapaAnterior="idEtapaAnterior"
          />
          <TablaPrioridadClinicaByOd
              v-else
              class="mt-3"
              ref="tablaPrioridadClinicaByOd"
              :aplicaPromocionesTx="aplicaPromocionesTx"
              :existePlan="existePlan"
              :tratamientosPrioridadPorOD="tratamientosPrioridadPorOD"
              :idPti="parseInt(idPti)"
              :idSolicitudEtapa="parseInt(idSolicitudEtapa)"
              :idSolicitud="parseInt(idSolicitud)"
              :idEtapaAnterior="idEtapaAnterior"
              :promociones="promociones"
              :loaderPrioridad="loaderPrioridad"
              :totalPrioridadClinica="totalPrioridadClinica"
              @montoAhorradoPromoByOD="montoAhorradoPromoByOD"
              @montosByRetiroPromoOd="montosByRetiroPromoOd"
              @enviarIndividualAHallazgoOd="enviarIndividualAHallazgoOd"
              @agregarAResumenInversionOD="agregarAResumenInversionOD"
          />
        </div>


        <div v-show="opcionTabSeleccionada === 1" class="text-left" style=" margin-top: 8px;">
          <div class="d-flex justify-content-between" style="margin-top: -1%;">
            <div class="d-flex align-items-center" style="height: 30px;">
                <em class="estrellaMargin" style="margin-top: -4%;"/>
                <p class="ml-2" style="color: #05375C; font-size: .8em; font-weight: 600; margin-top: 7%;">Hallazgos adicionales</p>
            </div>
          </div>


          <TablaHallazgosAdicionales
              :tratamientosHallazgosAdicionales.sync="tratamientosHallazgosAdicionales"
              @enviarAPrioridad="enviarAPrioridad"
              :existePlan="existePlan"
          />
        </div>



      </div>
    </b-col>

    <b-col lg="4" xl="4" sm="6" md="6" >
      <b-card class="contenedorResumen text-left" >
        <div class="d-flex justify-content-between">
          <p style="color: #4C9CCD; font-size: 12px; font-weight: 600;">Resumen de Inversión</p>
          <b-button v-if="vista" size="sm" variant="outline-info" pill
              v-b-tooltip.hover.lefttop.v-light
              title="Ver odontograma" style="width: 25px; height: 25px" class="pl-0 pr-0 ml-2"
              @click="vista = !vista">
            <em class="dienteAzulClaro_svg"/>
          </b-button>
         <!--  <b-button v-if="vista" size="sm" pill  variant="outline-info" @click="vista = !vista"
                      v-b-tooltip.hover.top.v-light
                      title="Ver odontograma">
               <em class="dienteAzul" style="width: 10px" ></em>
            </b-button> -->
          <!--   <b-button v-if="!vista" size="sm" pill variant="outline-info" @click="vista = !vista"
                      v-b-tooltip.hover.top.v-light
                      title="Ver resumen de inversión">
              <em class="moneda"
                  > </em>
            </b-button> -->
            <b-button v-if="!vista" size="sm" variant="outline-info" pill
              v-b-tooltip.hover.lefttop.v-light
              title="Ver resumen de inversión" style="width: 25px; height: 25px" class="pl-0 pr-0 ml-2"
              @click="vista = !vista">
            <em class="moneda"/>
          </b-button>
        </div>

        <TablaResumenInversion
        v-show="vista"
        ref="tablaResumenInversion"
        :tratamientosInversionProp.sync="tratamientosPrioridad"
        :inversionTotalCarrito="inversionTotalCarrito"
        :llenarArray.sync="llenarArray"
        @activarCarritoPrioridadClinica="activarCarritoPrioridadClinica"
        @activarCarritoPrioridadPorOD="activarCarritoPrioridadPorOD"
        :presuntivoSeleccionado="presuntivoSeleccionado"
        :montoAhorradoPromoProp="montoAhorradoPromo"
        :idPaciente="datosPacienteBasico.idPaciente"
        :contactosPaciente="datosPacienteBasico.mediosContacto"
        :listaMotivosPti="listaMotivosPti"
        @guardarOpcionAceptada="guardarOpcionAceptada"
        :loading="loading"
        :presuntivos="presuntivos"
        :montoAhorradoPlan="montoAhorradoPlan"
        :nombrePlan.sync="nombrePlan"
        :existePlan="existePlan"
        :agrupadoPorODProp="agrupadoPorOD"
        :totalPrioridadParaPlazos="totalPrioridadParaPlazos"
        />
        <div v-if="!vista" class="ml-3" style="width: 92%;">
          <odontograma
              :disable="true"
              :dientesSeleccionados="dientesSeleccionados"
              :multiplesDientesSeleccionados="[]"/>
        </div>
      </b-card>
    </b-col>
  </b-row>
  </b-container>

  <div v-if="mostrarModalPlazos" id="modal-container">
    <ConfiguracionPlazosPtiModal ref="modalConfiguracionPlazos" :titulo-modal="'Prioridad Clínica'" @cerrar="cerrarModal" :modalAbierto="mostrarModalPlazos" :inversionTotal="totalPrioridadParaPlazos" @guardarOpcionAceptada="imprimirEntregable" :blnEntregable="true"/>
  </div>
</div>
</template>

<script>
import Header from "@/components/Header";
import TablaPrioridadClinica from "@/version5/negociacion/TablaPrioridadClinica";
import TablaResumenInversion from "@/version5/negociacion/TablaResumenInversion";
import TablaHallazgosAdicionales from "@/version5/negociacion/TablaHallazgosAdicionales";
import Odontograma from '../../version5/diagnostico/NuevoOdontograma.vue';
import {PromocionesService} from "@/apiServices/promociones/PromocionesService";
import HerramientasModal from "@/version5/herramientas/componentes/HerramientasModal.vue";
import ObservacionesCita from "@/version5/cita/componentes/ObservacionesCita.vue";
import TablaPrioridadClinicaByOd from "@/version5/negociacion/TablaPrioridadByOd.vue";
import ConfiguracionPlazosPtiModal from "@/components/configuracionPlazosPti/configuracionPlazosPtiModal.vue";

export default {
  name: "resumenInversion",
  components: {
    ConfiguracionPlazosPtiModal,
    TablaPrioridadClinicaByOd,
    ObservacionesCita,
    HerramientasModal,
    Odontograma, TablaHallazgosAdicionales, TablaResumenInversion, TablaPrioridadClinica, Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    loaderPrioridad: false,
    idEtapaAnterior: null,
    promocionesServicio: new PromocionesService(),
    tratamientosPrioridad:[],
    tratamientosPrioridadPorOD:[],
    tratamientosInversion:[],
    tratamientosHallazgosAdicionales:[],
    opcionTabSeleccionada: 0,
    presuntivoSeleccionado: 1,
    dientesSeleccionados: [],
    promociones: [],
    totalPrioridadClinica: 0,
    inversionTotalCarrito: 0,
    opciones: [
      {nombre: "Prioridad clínica"},
      {nombre: "Hallazgos adicionales"},
    ],
    presuntivos: [],
    vista:true,
    idPti: null,
    idSolicitud: null,
    idSolicitudEtapa: null,
    idEtapa: null,
    llenarArray: false,
    agrupadoPorOD: false,
    montoAhorradoPromo: 0,
    datosPacienteBasico: {
      idPaciente: null,
      nombreCompleto: null,
      motivoCita: null,
      idSesion: null,
      idCita: null
    },
    listaMotivosPti: [],
    loading: false,
    montoAhorradoPlan: 0,
    nombrePlan: null,
    existePlan: false,
    arrayInicialLimpio: null,
    loaderPdf: false,
    registroActivo: null,
    mostrarModalPlazos: false,
    totalPrioridadParaPlazos: 0
  }),
  watch: {
    presuntivoSeleccionado(){
      this.llenarArray = false;
      this.actualizarPreciosClinica();
    //  this.obtenerTratamientosApartados();
    },
    tratamientosInversion() {
      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();
    }
  },
  computed: {
    aplicaPromocionesTx() {
      return this.promociones.some(p => p.tratmientosDescuento.some(td => {
            const existe00 = this.tratamientosPrioridad.some(tp => {
              let existe0;
              if (tp.tratamientos != null) {
                existe0 = tp.tratamientos.some(tp1 => {
                  //console.info(td.idTratamiento, tp1.idTratamiento,tp1.idTratamiento == td.idTratamiento);
                  return td.idTratamiento === tp1.idTratamiento
                });
              } else {
                existe0 = td.idTratamiento === tp.idTratamiento;
              }
              //console.info("-------", existe0);
              return existe0;
            })
            //console.info("-------", existe00);
            return existe00;
          }
      ));
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idPti = this.$route.params.idPti;
    this.idSolicitud = this.$route.params.idSolicitud;
    this.idSolicitudEtapa = this.$route.params.idSolicitudEtapa;
    this.idEtapa = this.$route.params.idEtapa;
    this.obtenerDatosPacienteBasico();
    this.traerMotivoPaciente();
    this.obtenerEstatusEdicion();
  },
  methods: {
    async obtenerEstatusEdicion(){
      const params = {
        idSolicitud: this.idSolicitud,
      }
      if (this.idEtapa == 97){
        await this.$http.post(this.$api + "edicion/obtener/estatusEdicion", params)
            .then((resp) => {
              this.registroActivo = resp.data.data
              if (!this.registroActivo) {
                this.$swal({
                  width: '650px',
                  icon: 'warning',
                  title: "<h6 style='font-size: 12px' ><b>La solicitud de Edición PTI ha sido cancelada</b></h6>",
                  html: '<div style="font-size: 12px"> ¡Por favor verifique la información! </div> <br>',
                  showCloseButton: true,
                  showCancelButton: false,
                  confirmButtonText: 'De acuerdo',
                  confirmButtonColor: 'rgb(110,163,197)',
                  customClass: {
                    confirmButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
                    cancelButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
                  },
                }).then((aceptar) => {
                  if (aceptar.value) {
                    this.$router.push('/bandeja/seguimiento');
                  }
                })
              }
            })
      }
    },

    agruparPorOd(agrupadoOd){
      this.$swal({
        width: '650px',
        icon: 'warning',
       // title: 'Impresión de opciones de PTI',
        text: 'Si cambia de agrupación se perderá el progreso',
        showCloseButton: false,
        showCancelButton: true,
        confirmButtonText: 'De acuerdo',
        confirmButtonColor: '#eeba6d',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#595959',
        customClass: {
          confirmButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
          cancelButton: 'pl-5 pr-5 ml-1 ml-sm-5 rounded-pill'
        },
      }).then((resultado) => {
        if (resultado.isConfirmed){
          this.agrupadoPorOD = agrupadoOd;

          this.obtenerTratamientosApartados();

        }
      })
    },
    async guardarOpcionAceptada(tratamientoInversion, invTotalCarrito) {

      await this.obtenerEstatusEdicion();
      if (this.idEtapa == 97 && !this.registroActivo){
        return;
      }

       console.info(">>>>guardarOpcionAceptada", this.tratamientosPrioridadPorOD, this.agrupadoPorOD);
      this.loading = true;
      const parametros = {
        prioridadClinica: this.agrupadoPorOD ? this.tratamientosPrioridadPorOD : this.tratamientosPrioridad,
        hallazgosAdicionales: this.tratamientosHallazgosAdicionales,
        resumenInversion: tratamientoInversion,
        totalPrioridadClinica: 0,
        inversionTotalCarrito: invTotalCarrito,
        idSolicitud: this.idSolicitud,
        idEtapa: this.idEtapa,
        idSolicitudEtapa: this.idSolicitudEtapa,
        idPti: this.idPti,
        idClinica: this.$localStorageService.getIdClinica(),
        opcion: this.presuntivoSeleccionado,
        agrupadoPorOd: this.agrupadoPorOD
      }
      const envio = JSON.parse(JSON.stringify(parametros))
      this.$http.post(this.$api +
          "procesoPtiV5/guardarOpcionAceptadaPti", envio
      )
          .then((response) => {
            if (response.data.data){
                  this.loading = false
             if (invTotalCarrito === 0){
               if (this.idEtapa == 97) {
                 this.$router.push({
                   name: "impresionPtiv5",
                   params: {
                     idPti: this.idPti,
                     idSolicitudEtapa: response.data.data,
                     idSolicitud: this.idSolicitud,
                     idEtapa: 100,
                     opcion: this.presuntivoSeleccionado
                   }})
               } else {
                 this.$router.push({
                   name: "impresionPtiv5",
                   params: {
                     idPti: this.idPti,
                     idSolicitudEtapa: response.data.data,
                     idSolicitud: this.idSolicitud,
                     idEtapa: 94,
                     opcion: this.presuntivoSeleccionado
                   }})
               }
              }else {
                this.$router.push({
                  name: "metodosPago",
                  params: {
                    idPti: this.idPti,
                    idSolicitudEtapa: response.data.data,
                    idSolicitud: this.idSolicitud,
                    idEtapa: this.idEtapa == 97 ? 98 : 90,
                    opcion: this.presuntivoSeleccionado
                  }})
              }

            }

          }).catch((error) => {
            this.$swal.fire({
              position: "center",
              icon: "error",
              title: error.response.data.message,
              showConfirmButton: false,
              timer: 2500,
            });
          }).finally(() => {
                this.loading = false;
         })
    },
    traerMotivoPaciente() {
      const url = this.$api + "catalogos/listaRespuestaM2";
      this.$http
          .get(url)
          .then((response) => {
            this.listaMotivosPti = response.data.data;
          })
          .catch((err) => {
            this.mostrarError(err);
          });
    },
    enviarAPrioridad(tratamientos) {
      if (this.agrupadoPorOD) {

        this.enviarAPrioridadPorOd(tratamientos);
      } else {
        if (tratamientos.tratamientosKits !== null && tratamientos.tratamientosKits.length > 0) {
          tratamientos.tratamientosKits.forEach(tKit => {
            tKit.clasificacion = 1;
            tKit.agregadoACarrito = false;
            tKit.banderaMovimientosHallPrio = 2
            tKit.tratamientos.forEach(kitTx => {
              kitTx.clasificacion = 1
              kitTx.agregadoACarrito = false;
            })

            this.tratamientosPrioridad.forEach(trat => {
              trat.tratamientos.forEach(tp => {
                if (tp.idDiente === tratamientos.idDiente) {
                  if (tp.idKitTratamiento === tKit.idKitTratamiento) {
                    tp.clasificacion = 1;
                    trat.clasificacion = 1;
                    tp.agregadoACarrito = false;
                    trat.agregadoACarrito = false
                    tp.banderaMovimientosHallPrio = 2
                  }
                }
              })
            })
          })





        }

        tratamientos.tratamientos.forEach(t => {
          if (t.clasificacion === 2) {
            t.clasificacion = 1;
            t.banderaMovimientosHallPrio++
            this.tratamientosPrioridad.forEach(trat => {
              trat.tratamientos.forEach(tp => {
                if (tp.idPtiTratamiento === t.idPtiTratamiento) {
                  tp.clasificacion = 1;
                  trat.clasificacion = 1;
                  tp.agregadoACarrito = false;
                  trat.agregadoACarrito = false
                  tp.banderaMovimientosHallPrio = 2


                  trat.inversionTotal = trat.tratamientos.filter(it => it.clasificacion === 1).reduce((vAnterior, vActual) => {
                    return vAnterior + vActual.total;
                  }, 0);
                }
              })
            })
          }
        })

        this.tratamientosPrioridad.forEach(d => d.dientesAgrupados = []);

        //this.llenarArrayDientesPrioridad();
        this.llenarArrayDientesPrioridadYDiente();
      }

      if (!this.agrupadoPorOD) {
        this.$refs.tablaPrioridadClinica.recalcularPorHallazgos();
      } else {
        this.$refs.tablaPrioridadClinicaByOd.recalcularPorHallazgos();
      }
    },
    enviarAPrioridadPorOd(tratamientos) {
      if (tratamientos.tratamientosKits !== null && tratamientos.tratamientosKits.length > 0) {
        tratamientos.tratamientosKits.forEach(tKit => {
          tKit.clasificacion = 1;
          tKit.agregadoACarrito = false;
          tKit.tratamientos.forEach(kitTx => {
            kitTx.clasificacion = 1
            kitTx.agregadoACarrito = false;
          })
        })

        this.tratamientosPrioridadPorOD.forEach(tp => {
          tp.tratamientos.forEach(t => {
            if (tratamientos.tratamientosKits.some(txKit => txKit.idKitTratamiento === t.idKitTratamiento)) {
              t.clasificacion = 1;
              t.agregadoACarrito = false;
              t.tratamientosKits.forEach(txkit => {
                txkit.clasificacion = 1
                txkit.agregadoACarrito = false;
                txkit.banderaMovimientosHallPrio ++
                tp.banderaMovimientosHallPrio ++
                t.banderaMovimientosHallPrio ++
              });
              tp.clasificacion = 1;
              tp.agregadoACarrito = false;
            }
          })
        })
      }

      if (tratamientos.tratamientos !== null && tratamientos.tratamientos.length > 0) {
        tratamientos.tratamientos.forEach(t => {
          t.banderaMovimientosHallPrio++
          t.clasificacion = 1;
          t.agregadoACarrito = false;
          this.tratamientosPrioridadPorOD.forEach(tp => {
            tp.tratamientos.forEach(tx => {
              if (t.idPtiTratamiento === tx.idPtiTratamiento) {
                tx.clasificacion = 1;
                tp.clasificacion = 1;
                tx.agregadoACarrito = false;
                tp.agregadoACarrito = false;
                tp.banderaMovimientosHallPrio++;
                tx.banderaMovimientosHallPrio++;
              }
            })

            tp.subtotal = tp.tratamientos.reduce((vAnterior, vActual) => {
              return vAnterior + vActual.subtotal;
            }, 0);
            tp.inversionTotal = tp.tratamientos.reduce((vAnterior, vActual) => {
              return vAnterior + vActual.total;
            }, 0);
          })
        })
      }
    },
    montosByRetiroPromo(item){

        //console.info(" .... 09000");
            //.filter(ti => ti.agregadoACarrito)
        this.tratamientosPrioridad.forEach(tp => {
          //console.info(">>>>quitarPromo 0", tp.tratamientos);
          tp.descuentoPromo = 0;
          tp.inversionTotal = 0;
          tp.tratamientos.forEach(trat => {

            if (trat.idPtiTratamiento == item.idPtiTratamiento) {

              const totalPlan = trat.montoPlanDescuento==null?0:trat.montoPlanDescuento*trat.cantidadAceptada;
              const totalVale = trat.montoValeDescuento==null?0:trat.montoValeDescuento*trat.cantidadAceptada;
              let totalOriginal = trat.subtotal-(totalPlan+totalVale);

              trat.promocion = null;
              trat.descuentoPromo = 0;
              trat.inversionTotal = totalOriginal;
              trat.total = trat.inversionTotal;
              //console.info(">>>>quitarPromo 00",JSON.stringify(tp.descuentoPromo),  JSON.stringify(trat.total));
            }

            tp.descuentoPromo += trat.descuentoPromo;
            tp.inversionTotal += trat.total;
            //console.info(">>>>quitarPromo 1",JSON.stringify(tp.descuentoPromo),  JSON.stringify(trat.total), JSON.stringify(tp.inversionTotal));
          });
          //console.info(">>>>quitarPromo 2: TOTAL",JSON.stringify(tp.descuentoPromo),  JSON.stringify(tp.inversionTotal), this.tratamientosPrioridad);
        })

        /*this.tratamientosInversion.filter(ti => ti.agregadoACarrito).forEach(i => {

            i.descuentoPromo = 0;
            i.inversionTotal = 0;
            i.tratamientos.forEach(trat => {
              trat.promocion = null;
              i.descuentoPromo += trat.descuentoPromo;
              i.inversionTotal += trat.total;
            })

        })*/



        /*this.tratamientosInversion.forEach(i => {
          if (item.idKitTratamiento === null){
            if (i.idPtiTratamiento=== item.idPtiTratamiento){
           //   console.log("apoco entra aqui ??? ")
              let montos = 0;
              i.tratamientos.forEach(tr => {
                //console.info(" .... 10", JSON.stringify(tr.total), JSON.stringify(tr.descuentoPromo));
                tr.descuentoPromo = 0
                montos += tr.total;
                tr.promocion = null;
              });

              i.inversionTotal = montos;
              i.descuentoPromo = 0;
              i.promocion = null;
            }
          } else {

            if (i.idKitTratamiento === item.idKitTratamiento && (i.idDiente === item.idDiente)){
             // let montos = 0;

              i.tratamientos.forEach(tr => {
                tr.total = tr.subtotal;
                tr.total = tr.total - tr.descuentoPromo
              //  console.info("Que pasas ?? ", tr);
                if (item.idPtiTratamiento == tr.idPtiTratamiento){
                  //console.info(" .... 10", JSON.stringify(tr.total), JSON.stringify(tr.descuentoPromo));
                  const totalPlan = tr.montoPlanDescuento==null?0:tr.montoPlanDescuento*tr.cantidadAceptada;
                  const totalVale = tr.montoValeDescuento==null?0:tr.montoValeDescuento*tr.cantidadAceptada;
                  let totalOriginal = tr.subtotal-(totalPlan+totalVale);

                  tr.promocion = null;
                  tr.descuentoPromo = 0;
                  tr.inversionTotal = totalOriginal;
                  tr.total = tr.inversionTotal;
                }


                if (tr.promocion != null && tr.promocion.promocionForzosa){
                  console.log(tr.total)
                }else{
                  // tr.total = tr.total - tr.descuentoPromo;
                  console.log("tr.total >>>>>>>>>>yes>>>>>>>>", tr.total)
                 //  montos += tr.total
                }

             //   tr.total = tr.total - tr.descuentoPromo
              });

             // i.inversionTotal = montos
              i.inversionTotal = i.tratamientos.reduce((vAnterior, vActual) => {
                return vAnterior + vActual.total;
              }, 0);
              console.log(i.inversionTotal)
              //i.descuentoPromo = 0;
              //i.promocion = null;
            }
          }

        });*/

      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();
    },

    montosByRetiroPromoOd(item) {
      let montos = 0;

        this.tratamientosInversion.forEach(i => {
          let sumaPromo = 0;
          if (i.idTratamiento === item.idTratamiento){
            i.tratamientos.forEach(tx => {
              if (tx.idPtiTratamiento === item.idPtiTratamiento && item.idDiente === tx.idDiente) {
                tx.total += tx.descuentoPromo;
                tx.promocion = null;
                tx.descuentoPromo = 0
              }


              if (tx.agregadoACarrito){
                sumaPromo += tx.descuentoPromo;
                montos += tx.total;
              }

            })
            i.descuentoPromo = sumaPromo;
            i.inversionTotal = montos;
            i.promocion = null;

          }
        });


      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();



    },

    montoAhorradoByPromocion(dioClick, tratamiento){
      let costo = 0;
      let banderaReCostoPrioridadByKits = false;

      //Actualiza en la tabla prioridad clinica los totales (SOLO PARA KITS)
      this.tratamientosPrioridad.filter(ti => ti.clasificacion === 1).forEach(tp =>{
          banderaReCostoPrioridadByKits = true;
          tp.descuentoPromo = 0;
          tp.inversionTotal = 0;
          //console.info(">>>>montoAhorradoByPromocion 0", tp.tratamientos, itemTrtPrioridad);
          tp.tratamientos.forEach( trat => {

            tp.descuentoPromo += trat.descuentoPromo;
            tp.inversionTotal += trat.total;

            //console.info(">>>>montoAhorradoByPromocion 1  ", JSON.stringify(trat.descuentoPromo), JSON.stringify(trat.total), JSON.stringify(tp.inversionTotal), trat);
          })
          //console.info(">>>>montoAhorradoByPromocion 2  ", JSON.stringify(tp.descuentoPromo), JSON.stringify(tp.inversionTotal));
        costo += tp.inversionTotal
      })

      this.tratamientosInversion.forEach(t => {

        //console.info("---actualizar inversion datos ", t.idPtiTratamiento, itemTrtPrioridad.idPtiTratamiento, t);

        //Actualizo los totales del lado de la tabla de inversion
        const tratsP = t.tratamientos.map(tratP=>tratP.idPtiTratamiento);
        //console.info(" .... 1", tratsP);
        t.inversionTotal = 0;
        this.tratamientosPrioridad.forEach(tratPrioridad =>{
          const tratP = tratPrioridad.tratamientos.some(tratPrioridadTrat => tratsP.includes(tratPrioridadTrat.idPtiTratamiento));
          if (tratP) {
            if(dioClick){
              const idPtiTxSeleccionado = tratamiento.tratamientos != undefined ? tratamiento.tratamientos.map(tratP=>tratP.idPtiTratamiento) : [tratamiento.idPtiTratamiento];
              const idPtiTxItem = t.tratamientos.map(tratP=>tratP.idPtiTratamiento);
              if(t.idTratamiento === tratamiento.idTratamiento && idPtiTxSeleccionado === idPtiTxItem){
                let txsAgregadoACarrito = tratPrioridad.tratamientos.filter(tratPrioridadInd => tratPrioridadInd.agregadoACarrito).length;
                t.inversionTotal = tratamiento.total * txsAgregadoACarrito;
              }else{
                t.inversionTotal = tratPrioridad.inversionTotal;
              }
            }else{
              t.inversionTotal = tratPrioridad.inversionTotal;
            }
            t.descuentoPromo = tratPrioridad.descuentoPromo;
            t.total = t.inversionTotal;
          }
        });

        //Actualizo los detalles del lado de la tabla de inversion
        t.tratamientos.forEach(tratInversionInd => {
          this.tratamientosPrioridad.forEach(tratPrioridadMain =>{
            const tratPrioInd = tratPrioridadMain.tratamientos.find(tratPrioridadInd => tratPrioridadInd.idPtiTratamiento == tratInversionInd.idPtiTratamiento);
            if (tratPrioInd != null) {
              tratInversionInd.promocion = tratPrioInd.promocion;
              tratInversionInd.descuentoPromo = tratPrioInd.descuentoPromo;
            }
          });
        });
        // console.info(">>>>montoAhorradoByPromocion dettrat", t.tratamientos);

      });

      console.log(banderaReCostoPrioridadByKits, costo)
      if (banderaReCostoPrioridadByKits){
        this.$refs.tablaPrioridadClinica.reCostearPrioridadByKits(costo);
      }

      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();
    },

    montoAhorradoPromoByOD(tratamiento){
      this.tratamientosInversion.forEach(ti => {

        ti.tratamientos.forEach(t =>{
          if (tratamiento.idPtiTratamiento === t.idPtiTratamiento ){

            t.descuentoPromo = tratamiento.descuentoPromo
            t.total = tratamiento.total
            t.promocion = tratamiento.promocion

          }
        })

        ti.descuentoPromo = ti.tratamientos.reduce((vAnterior, vActual) => {
          return vAnterior + vActual.descuentoPromo;
        }, 0);

        ti.inversionTotal = ti.tratamientos.reduce((vAnterior, vActual) => {
          return vAnterior + vActual.total;
        }, 0);

      })

      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();

    },

    enviarGrupoAHallazgo(tratamiento){
      this.tratamientosHallazgosAdicionales.forEach(h => {
        h.dientes.forEach(d => {
          if (d.idDiente === tratamiento.idDiente){
            d.tratamientos.forEach(t => {
              if (t.idTratamiento === tratamiento.idTratamiento){
                t.clasificacion = 2;
              }
            })
            d.tratamientosKits.forEach(t => {
              if (tratamiento.idKitTratamiento !== null && ( t.idKitTratamiento === tratamiento.idKitTratamiento) ){
                t.clasificacion = 2;
              }
            })
          }
        })
      })


    },

    enviarIndividualAHallazgo(tratamiento){

      this.tratamientosHallazgosAdicionales.forEach(h => {
        h.dientes.forEach(d => {
          if (d.idDiente === tratamiento.idDiente){
            d.tratamientos.forEach(t => {
              if (t.idTratamiento === tratamiento.idTratamiento){
                t.clasificacion = 2;
              }
            })
            d.tratamientosKits.forEach(t => {
              if (tratamiento.idKitTratamiento !== null && ( t.idKitTratamiento === tratamiento.idKitTratamiento) ){
                t.clasificacion = 2;
              }
            })
          }
        })
      })

      this.tratamientosPrioridad.forEach(tp => {
        tp.tratamientos.forEach(t => {
          if (t.idPtiTratamiento === tratamiento.idPtiTratamiento){
            t.clasificacion = 2;
            t.agregadoACarrito = false;
            console.log(tp.tratamientos.filter(t => t.clasificacion === 1).length === 0, " ******* ")

            if (tp.tratamientos.filter(t => t.clasificacion === 1).length === 0){
              tp.clasificacion = 2
            }

            tp.inversionTotal = tp.tratamientos.filter(it => it.clasificacion === 1).reduce((vAnterior, vActual) => {
              return vAnterior + vActual.total;
            }, 0);
          }

        })
      })


      this.tratamientosPrioridad.forEach(d => d.dientesAgrupados = []);
     // this.llenarArrayDientesPrioridad();
      this.llenarArrayDientesPrioridadYDiente();
 /*     this.agruparODTx();*/
    },
    enviarIndividualAHallazgoOd(tratamiento) {
      if (tratamiento.idKitTratamiento == null) {
        this.tratamientosHallazgosAdicionales.forEach(h => {
          h.dientes.forEach(d => {
            if (d.idDiente === tratamiento.idDiente) {
              d.tratamientos.forEach(t => {
                if (t.idTratamiento === tratamiento.idTratamiento) {

                  t.clasificacion = 2;
                }
              })
            }
          })
        })
      } else {
        this.tratamientosHallazgosAdicionales.forEach(h => {
          h.dientes.forEach(d => {
            if (d.idDiente === tratamiento.idDiente) {
              if (d.tratamientosKits.length > 0) {

                d.tratamientosKits.forEach(t => {
                  if (t.idKitTratamiento === tratamiento.idKitTratamiento) {
                    t.tratamientos.forEach(t1 => t1.clasificacion = 1)
                    t.clasificacion = 2;
                  }
                })
              }
            }
          })
        })

      }

      this.tratamientosPrioridadPorOD.forEach(tp => {
        tp.tratamientos.forEach(t => {
          if (t.idPtiTratamiento === tratamiento.idPtiTratamiento) {
            t.clasificacion = 2;
            t.agregadoACarrito = false;
            tp.inversionTotal -= t.total;
            tp.subtotal -= t.subtotal;
          }
        })

        if (!tp.tratamientos.some(t => t.clasificacion === 1)) {
          tp.clasificacion = 2;
        }
      })
    },


    pasarDePrioridadAHallazgo(datos){
      if (this.tratamientosHallazgosAdicionales.length === 0 ){
          this.tratamientosHallazgosAdicionales.push({
            idPadecimiento: datos.idPadecimiento,
            padecimiento: datos.padecimiento,
            dientes: []
          });
          this.tratamientosHallazgosAdicionales.forEach(t => {
            if (t.idPadecimiento === datos.idPadecimiento){
                datos.tratamientos.forEach(d => {
                  t.dientes.push({
                    idDiente: d.idDiente,
                    mostrarPrecios: false,
                    nombreDiente: "",
                    numeroDiente: d.diente,
                    tratamientos: new Array(d)
                  })
                })
            }
          })
      }
    },

    activarEnResumenInversion(tratamiento){


      this.tratamientosInversion.forEach(ti => {
        let sumPromo = 0;
        let sumTotal = 0;
        ti.dientesAgrupados = []
        ti.tratamientos.forEach(t => {
          if (t.idPtiTratamiento == tratamiento.idPtiTratamiento){
            t.agregadoACarrito = true;
            ti.agregadoACarrito = true;
          }else if (ti.idKitTratamiento !== null && (ti.idKitTratamiento === tratamiento.idKitTratamiento)){
            ti.agregadoACarrito = true;
            ti.tratamientos.forEach(k => k.agregadoACarrito = true)
          }

          if (t.agregadoACarrito){
            sumPromo += t.descuentoPromo;
            sumTotal += t.total;
            ti.dientesAgrupados.push(t.diente)
          }
        })
        ti.inversionTotal = sumTotal;
        ti.descuentoPromo = sumPromo;
      })

      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();
    },
    agregarAResumenInversionOD(tratamiento){

      if (tratamiento.idKitTratamiento !== null) {
        this.tratamientosInversion.forEach(ti => {
          if (ti.idKitTratamiento === tratamiento.idKitTratamiento){
            ti.agregadoACarrito = true;
            ti.tratamientos.forEach(trt => trt.agregadoACarrito = true)
          }
        })
      }else {


        this.tratamientosInversion.forEach(ti => {
          ti.tratamientos.forEach(trat => {
            if (tratamiento.idPtiTratamiento === trat.idPtiTratamiento ){
              trat.agregadoACarrito = true;
              ti.agregadoACarrito = true;
            }
          })

        })
      }
      this.$refs.tablaResumenInversion.recalcularInversionTotal();

    },

    agregarAResumenInversion(){
      /* if (porGrupoTratamiento){


          this.tratamientosPrioridad.forEach(t => {
            if (t.idTratamiento === datos.idTratamiento && t.idKitTratamiento == null && (t.idDiente === datos.idDiente )){
              t.inversionTotal = datos.inversionTotal;
              t.agregadoACarrito = true;
              t.tratamientos.forEach(i => i.agregadoACarrito = true)
            }
            else if (t.idKitTratamiento !== null && (t.idKitTratamiento === datos.idKitTratamiento) &&
                (datos.tratamientos.length > 0 && datos.tratamientos[0].idDiente === t.tratamientos[0].idDiente)){
              t.inversionTotal = datos.inversionTotal;
              t.agregadoACarrito = true
              t.tratamientos.forEach(i => i.agregadoACarrito = true)
            }

          })

        this.tratamientosInversion.forEach(ti => {
          if(ti.idTratamiento === datos.idTratamiento && ti.idKitTratamiento == null && (ti.idDiente === datos.idDiente)){
            ti.inversionTotal = datos.inversionTotal;
            ti.agregadoACarrito = true;
            ti.tratamientos.forEach(tr =>{
              tr.agregadoACarrito = true;
              tr.clasificacion = 1
            });
            ti.clasificacion = 1


          }else if (ti.idKitTratamiento !== null && (ti.idKitTratamiento === datos.idKitTratamiento) &&
              (datos.tratamientos.length > 0 && datos.tratamientos[0].idDiente === ti.tratamientos[0].idDiente) ) {
            ti.inversionTotal = datos.inversionTotal;
            ti.agregadoACarrito = true;
            ti.tratamientos.forEach(tr => {
              tr.agregadoACarrito = true;
              tr.clasificacion = 1;
            });
            ti.clasificacion = 1
          }
        });


        this.$refs.tablaResumenInversion.actualizarResumenInversion(datos);
        this.$refs.tablaResumenInversion.recalcularInversionTotal();
        this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();

      }else {
        this.tratamientosPrioridad.forEach(t => {
          if (t.idTratamiento === datos.idTratamiento){
            t.tratamientos.forEach(x => {
              if (x.idPtiTratamiento === datos.idPtiTratamiento){
                  x.agregadoACarrito = true;
                  t.agregadoACarrito = true;
              }
            })
          }
        })
        this.tratamientosInversion.forEach(ti => {
          if (ti.promocion != null){
            ti.descuentoPromo = ti.promocion.promoDescPesos;
          }
          ti.dientesAgrupados = [];
          ti.tratamientos.forEach(t => {
            if(t.idPtiTratamiento === datos.idPtiTratamiento){
              t.agregadoACarrito = true;
              ti.agregadoACarrito = true;

              ti.clasificacion = 1
              t.clasificacion = 1;

            }
            if (t.agregadoACarrito ){
              ti.dientesAgrupados.push(t.diente)
            }
          })

        });
        this.$refs.tablaResumenInversion.actualizarResumenInversion(datos);
        this.$refs.tablaResumenInversion.recalcularInversionTotal()



      }*/
      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();
      this.actualizarMontoAhorradoPlan();
    },

    activarCarritoPrioridadPorOD(tratamiento){

      if (tratamiento.idKitTratamiento !== null){
        this.tratamientosPrioridadPorOD.forEach(tp => {
          tp.tratamientos.forEach(trat => {
            if (trat.tratamientosKits !== null && trat.tratamientosKits.length > 0){
              if (trat.idKitTratamiento === tratamiento.idKitTratamiento){
                trat.agregadoACarrito = false;
                trat.tratamientosKits.forEach(tr => tr.agregadoACarrito = false);
              }
            }
          })
        })

      }else {

        this.tratamientosPrioridadPorOD.forEach(tp => {
          tp.tratamientos.forEach(trat => {
            if (tratamiento.tratamientos.find(t => t.idPtiTratamiento === trat.idPtiTratamiento)){
              trat.agregadoACarrito = false;
            }
          })
        })
      }

      this.$refs.tablaResumenInversion.recalcularInversionTotal();
      this.$refs.tablaResumenInversion.importanteRecalcularDescuentoPromo();
    },

    activarCarritoPrioridadClinica(datos, porGrupoTratamientos){

        if (porGrupoTratamientos){

          if (datos.idKitTratamiento === null ) {
            this.tratamientosPrioridad.forEach(t => {
              if (t.idTratamiento === datos.idTratamiento && (t.idDiente === datos.idDiente )) {
                t.inversionTotal = datos.inversionTotal;
                t.agregadoACarrito = false
                t.tratamientos.forEach(i => {
                  i.agregadoACarrito = false;
                //  i.cantidadAceptada = 0;
                })
              }
            })
          }
          else {
            this.tratamientosPrioridad.forEach(t => {
              if (t.idTratamiento === datos.idTratamiento && datos.tratamientos.length > 0 &&
                  (datos.tratamientos[0].idDiente === t.tratamientos[0].idDiente) ) {
                t.inversionTotal = datos.inversionTotal;
                t.agregadoACarrito = false
                t.tratamientos.forEach(i => i.agregadoACarrito = false)
              }
            })
          }

        }else {

          let agregados = null;
          this.tratamientosPrioridad.forEach(t => {
            t.tratamientos.forEach(x => {
              if (x.idPtiTratamiento === datos.idPtiTratamiento) {
                x.agregadoACarrito = false;
              }
            })
            if (t.idTratamiento === datos.idTratamiento) {
              agregados = t.tratamientos.filter(x => !x.agregadoACarrito).length
              if (t.tratamientos.length === agregados) {
                t.agregadoACarrito = false;
              }
            }
            t.dientesAgrupadosCarrito = [];
          })



          this.llenarArrayDientesPrioridadAInversion();

        }
      },
    actualizarPreciosClinica(){
      const params = {
        idPti: this.$route.params.idPti,
        idSolicitud:this.idSolicitud,
        idSolicitudEtapa: this.idSolicitudEtapa,
        opcion: this.presuntivoSeleccionado,
        clasificacion: 1,
        idClinica: this.$localStorageService.getIdClinica(),
        idEtapa: this.idEtapa,
        agruparPorOd: false
      }

      this.$http.post(this.$api + "procesoPtiV5/actualizar/precio/ptiTratamiento", params).then(resp=> {
        if (resp.data.data){
          this.obtenerTratamientosApartados();
        }
      })
    },
    obtenerTratamientosApartados(){
        const params = {
          idPti: this.$route.params.idPti,
          idSolicitud:this.idSolicitud,
          idSolicitudEtapa: this.idSolicitudEtapa,
          opcion: this.presuntivoSeleccionado,
          clasificacion: 1,
          idClinica: this.$localStorageService.getIdClinica(),
          idEtapa: this.idEtapa,
          agruparPorOd: this.agrupadoPorOD
        }
        this.loaderPrioridad = true;
        this.totalPrioridadClinica = 0;
        this.$http.post(this.$api + "procesoPtiV5/obtener/opcion/tratamientos/prioridadClinica", params).then(resp=> {
          if (resp.data.data){
            this.loaderPrioridad = false;
            /*Este if es agrupación por tratamientos*/
            if (!this.agrupadoPorOD){
              const apartados = resp.data.data
              this.arrayInicialLimpio =  JSON.parse(JSON.stringify(apartados));
              this.idEtapaAnterior = apartados.idEtapaAnterior

              this.tratamientosPrioridad = apartados.prioridadClinica;
             // this.tratamientosInversion = apartados.resumenInversion;
              this.totalPrioridadClinica = apartados.totalPrioridadClinica;
              this.inversionTotalCarrito = apartados.inversionTotalCarrito;
              this.tratamientosHallazgosAdicionales = apartados.hallazgosAdicionales;
              this.nombrePlan = apartados.nombrePlan
              this.existePlan = apartados.nombrePlan !== null || apartados.montoAhorradoPlan > 0 ? true : false;

              this.actualizarMontoAhorradoPlan();

              this.llenarArray = true;
              /*if (this.tratamientosInversion.length > 0){
                this.llenarArrayDientesInversion();
              }*/
              if (this.tratamientosPrioridad.length > 0){
                this.llenarArrayDientesPrioridad();
                //   this.agruparODTx()
              }
            }
            /*Aquí metemos lógica de agrupamiento por OD*/
            else {

              const apartados = resp.data.data
              this.arrayInicialLimpio =  JSON.parse(JSON.stringify(apartados));
              this.idEtapaAnterior = apartados.idEtapaAnterior

              this.tratamientosPrioridadPorOD = apartados.prioridadClinica;
              this.tratamientosInversion = apartados.resumenInversion;
              this.totalPrioridadClinica = apartados.totalPrioridadClinica;
              this.inversionTotalCarrito = apartados.inversionTotalCarrito;
              this.tratamientosHallazgosAdicionales = apartados.hallazgosAdicionales;
              this.nombrePlan = apartados.nombrePlan
              this.existePlan = apartados.nombrePlan !== null || apartados.montoAhorradoPlan > 0 ? true : false;

              this.actualizarMontoAhorradoPlan();

              this.llenarArray = true;
              if (this.tratamientosInversion.length > 0){
                this.llenarArrayDientesInversion();
              }

            }





          }
        }).finally( () => {
          if(!this.agrupadoPorOD){
            this.obtenerPromociones(this.presuntivoSeleccionado);
          }
        })
      },

    actualizarMontoAhorradoPlan(){
      //console.info(">>>actualizarMontoAhorradoPlan 00",this.tratamientosPrioridad)
      this.montoAhorradoPlan = this.tratamientosPrioridad.filter(ti => ti.agregadoACarrito).reduce((vAnterior, vActual) => {
        //console.info(">>>actualizarMontoAhorradoPlan 0",vAnterior, (vActual.descuentoPlan != null ? vActual.descuentoPlan : 0));
        return vAnterior + (vActual.descuentoPlan != null ? vActual.descuentoPlan : 0);
      }, 0);

      //console.info(">>>actualizarMontoAhorradoPlan", this.montoAhorradoPlan);
    },

    obtenerPromociones(opcion) {
      const fecha = this.$moment(new Date()).format("DD/MM/YYYY");
      // const idPx = this.datosPaciente.idPaciente
      const datos = {
        fecha: fecha,
        idClinica: this.$localStorageService.getIdClinica(),
        idPti: this.idPti,
        opcio: opcion,
        idCita: this.datosPacienteBasico.idCita
      }
      this.promocionesServicio
          .obtenerPromocionesPorPtiParaSDI(datos)
          .then((respuesta) => {
            this.promociones = respuesta;
          });
    },

    llenarArrayDientesInversion(){
      this.tratamientosInversion.forEach(m => {
        m.tratamientos.forEach(p => {
            m.dientesAgrupados.push(p.diente);

        })
      })
    },

    llenarArrayDientesPrioridadAInversion(){
      this.tratamientosPrioridad.forEach(m => {
        if (m.clasificacion === 1){
          m.tratamientos.forEach(p => {
            if (p.agregadoACarrito){
              m.dientesAgrupadosCarrito.push(p.diente)
            }
          })
        }

      })
    },

    llenarArrayDientesPrioridad(){
      this.tratamientosPrioridad.forEach(m => {
        if (m.clasificacion === 1){
          m.tratamientos.forEach(p => {
            m.dientesAgrupados.push(p.diente)
            m.dientesAgrupadosCarrito.push(p.diente)
          })
        }

      })
    },

    llenarArrayDientesPrioridadYDiente(){
      this.tratamientosPrioridad.forEach(m => {
        if (m.clasificacion === 1){
          m.tratamientos.forEach(p => {
            if (p.clasificacion === 1){
              /*console.log("p.diente", p.diente)*/
              m.dientesAgrupados.push(p.diente)
            }
          })
        }

      })
    },

    obtenerDatosPacienteBasico() {
      this.$http.post(this.$api + "paciente/obtenerDatosPacienteBasicoPorPti", this.traerParametrosPaciente()).then(respuesta => {
        if (respuesta.data.data) {
          this.datosPacienteBasico = respuesta.data.data;
          this.presuntivos = respuesta.data.data.presuntivos;
        }
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.actualizarPreciosClinica();
      //    this.obtenerTratamientosApartados();
      })
    },

    traerParametrosPaciente() {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      return {
        idPti: this.idPti,
        idUsuario: this.$localStorageService.getIdUsuario(),
        horaInicio: inicio,
        horaFin: fin,
        presentacion: true,
        idClinica: this.$localStorageService.getIdClinica()
      };
    },

    imprimirEntregable(datos = null) {
      this.loaderPdf = true;
        const parametros = {
          prioridadClinica: this.agrupadoPorOD ? this.tratamientosPrioridadPorOD : this.tratamientosPrioridad,
          hallazgosAdicionales: this.tratamientosHallazgosAdicionales,
          nombrePlan: this.nombrePlan,
          montoAhorradoPlan: this.montoAhorradoPlan,
          montoAhorradoPromocion: this.$refs.tablaResumenInversion.montoAhorradoPromo,
          totalPrioridadClinica: 0,
          inversionTotalCarrito: this.$refs.tablaPrioridadClinica.cantidadtotalPrioridad,
          idSolicitud: this.idSolicitud,
          idEtapa: this.idEtapa,
          idSolicitudEtapa: this.idSolicitudEtapa,
          idPti: this.idPti,
          idClinica: this.$localStorageService.getIdClinica(),
          opcion: this.presuntivoSeleccionado,
          montoFinanciar: datos ? datos.montoFinanciar : null,
          mesesPlazoFijo: datos ? datos.mesesPlazoFijo : [],
        }

        this.$http.post(this.$api + "pdfImpresionPTI/imprimirEntregableNegociacion", parametros).then(respuesta => {
          this.downloadPDF("data:application/pdf;base64," + respuesta.data.data);
          this.$swal.fire({
            position: "center",
            icon: "success",
            title: "impresión generada correctamente",
            showConfirmButton: false,
            timer: 3000,
          });
        }).catch(error => {
          console.error(error)
          this.$swal({
            position: "center",
            icon: "error",
            title: "Ocurrio un error",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }).finally(() => {
          this.loaderPdf = false;
        })


    },

    downloadPDF(base64) {
      const linkSource = base64;
      const downloadLink = document.createElement("a");
      const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];

      const fileName = 'M2_'+this.datosPacienteBasico.nombreCompleto.replaceAll(' ', '_')+'_'+dia+'_'+mes+'_'+anio;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },

    setCantidadTotal(param){
      this.totalPrioridadParaPlazos = param;
    },
    cerrarModal() {
      this.mostrarModalPlazos = false;
    },
    alertImprimir(){
      this.$swal.fire({
        icon: "warning",
        title: "Impresión de PTI",
        html:
            ' SE HARA LA IMPRESIÓN CON LOS DATOS POR DEFECTO, ¿DESEA CONTINUAR? </div>' +
            '<b-button id="open-modal-btn"  size="md" v-b-tooltip.hover.lefttop.v-light variant="outline-info" pill title="Configurar plazos para impresión" style="width: 28px; height: 28px; background-color: #1b81af; border-radius: 50%; border: solid 1px #1b81af; position: absolute;top: 10px; right: 35px;" class="mt-1 d-flex align-items-center justify-content-center"><em class="fa fa-calendar" style="color: #FFF; margin-top: 2px; margin-left: 1px;"/></b-button>' ,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "No, cancelar",
        confirmButtonColor: "#1b81af",
        cancelButtonColor: "#fff",
        customClass: {
          confirmButton: "rounded-pill text-small",
          cancelButton: " rounded-pill text-small border border-secondary text-secondary",
        },
        onOpen: () => {
          document.getElementById("open-modal-btn").addEventListener("click", () => {
            this.$swal.close();
            this.mostrarModalPlazos = true;
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.imprimirEntregable()
        }
      });
    }

  }
}

</script>

<style scoped>
.container-nombre {
  display: flex;
  justify-content: center;
}

.row-nombre {
  width: 50%;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 29px;
}
.letterSizeSm{
  font-size: .75em;
  font-weight: 600;
}
.contenedorInversion {
  border:1px solid  #E0E0E0;
  border-radius: 1rem;
  width: 102%;
  height: 95vh;
  background-color: #fff;
  padding-left: 2%;
  padding-right: 2%;
 /* overflow: scroll;*/
}

.contenedorResumen {
  border:1px solid  #E0E0E0;
  border-radius: 1rem;
  width: 101%;
  height: 95vh;
  background-color: #fff;
  padding-left: 1%;
  padding-right: 1%;
 /* overflow: scroll;*/
}

.cardsP {
  border:1px solid  #E0E0E0;
  border-radius: 1rem;
  width: 102%;
  height: 590px;
  background-color: #fff;
}
.box {
  width: 60%;
  background: #ffffff;
  border-radius: 20px;
  height: 6vh;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
}

.tabTxtSeleccionado {
  font-size: 10px;
  color: #17a2b8;
  width: 100%;
  font-weight: 600;
}

.tabTxt {
  font-size: 10px;
  color: #717171;
}

.tabOpciones.seleccionado {
  border-style: solid;
  border-width: 1px;
  border-color: #90d3dd;
  border-radius: 10px;
  color: #17a2b8;
  text-align: center;
}

.tabOpciones:hover {
  font-weight: 600;
  text-align: center;
}
.presuntivos {
  border-style: solid;
  border-radius: 20px;
  color: #E9E9E9;
  background-color: #E9E9E9;
  cursor: pointer;
  width: 200px;
}
.presuntivos.seleccionado {
  border-style: solid;
  border-color: #90d3dd;
  border-radius: 20px ;
  color: #17a2b8;
  background-color: #FFFFFF;
  width: 200px;
}

.presuntivos:hover {
  font-weight: 600;
  /*color: #17a2b8;*/
}
.tabpresuntivosSeleccionado {
  font-size: 10px;
  color: #17a2b8;
  width: 100%;
  font-weight: 600;
}

.tabpresuntivos {
  font-size: 10px;
  color: #7b7b7b;
}
.tabs .tabs-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.tabs .tabs-nav ul li {
  flex: 1 0 auto;
  margin: 0;
  border-bottom: 3px solid transparent;
}

.tabs .tabs-nav ul li a {
  display: block;
  padding: 0.4em 2em 0.4em 2em;
  border: none;
  color: #aaaaaa;
}

.tabs .tabs-nav ul li a:hover {
  /* al sobre poner el mouse */
  cursor: pointer;
  color: #369bda;
}

.border {
  /* borde inferior */
  border-bottom: 3px solid #0069a9;
  width: 20%;
}

.tabs .tabs-nav ul li.active a {
  color: #0069a9;
  font-weight: 600;
}

.tabs .tabs-content {
  width: 100%;
}

.rounded-pill.text-small.outline-secondary{
  background-color: white;
  color: var(--secondary-color);
  border-color: var(--secondary-color);
}




</style>
